import React from 'react';
const items = ['Live on Zoom', 'Friday, October 16 · 7:15 PM CT', 'Replay included'];
export function AnnouncementBar() {
  return <div className="w-full bg-gold" data-id="element-16" data-mp="ollmnjfr9fk4">
      <p className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-6 py-2.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink" data-id="element-17" data-mp="jttu53d1gzrc">
        {items.map((item, i) => <React.Fragment key={item} data-id="element-18" data-mp="9w5wo5o1te5h" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" data-id="element-19" data-mp="9ttafgb9chmm">·</span>}
            <span data-id="element-20" data-mp="5u2jnclqe1i3">{item}</span>
          </React.Fragment>)}
      </p>
    </div>;
}